import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { ShortEncryptorService } from '../../../services/short-encryptor.service';
import { UserFormComponent } from '../user-form/user-form.component';
import { ViewKycComponent } from '../../demos/view-kyc/view-kyc.component';
import { OrgViewComponent } from '../../organization/org-view/org-view.component';

@Component({
	selector: 'app-user-list',
	imports: [CommonModule, UserFormComponent, FormsModule, ViewKycComponent, OrgViewComponent],
	templateUrl: './user-list.component.html',
	styleUrl: './user-list.component.scss',
})
export class UserListComponent {
	@Input() user: any;
	@Input() action: any;

	base = 'users';		// important for API calls
  
  // user: any = null;
  btnClick: string = "";
  loading = false;
  isEdit = false;
  isTrial = false;
	headers: any = null;
	allData: any = [];
  allKycs: any = [];
  allxData: any = [];
  allSchemas: any = [];
  selUser: any = null;
  urType = '';    // 'T', 'K', 'P' Trial, KYC and Paid users
  selOrg: any = {};

	constructor(public dataService: DataService, private shCrypt: ShortEncryptorService) {
		//
	}

	async ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem && !this.user) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

    // this.loading = true;
    // await this.dataService.getAllRecords('kyc').then((res: any) => {
    //   this.allKycs = res;
		// 	this.loading = false;
    // });

    this.loading = true;
    await this.dataService.getAllRecords(this.base).then((res: any) => {
      this.allData = res || [];
      this.allxData = res || [];

      for(let i=0; i<this.allData?.length; i++) {
        const user_role: any = this.allData[i].user_role;

        if(typeof user_role == 'string') {
          this.allData[i].user_role = this.dataService.str2json(user_role);
        }
			}

      this.loading = false;
    });

    if(this.user && this.user.user_role[0].code=='spr') {
      this.loading = true;
      // Fetch all schema users from all trial schemas
      await this.dataService.getAllRecords('kyc-users').then((res: any) => {
        this.allSchemas = res || [];

        for(let i=0; i<this.allSchemas?.length; i++) {
          if(typeof this.allSchemas[i].user_role == 'string') {
            this.allSchemas[i].user_role = this.dataService.str2json(this.allSchemas[i].user_role);
          }
          if(typeof this.allSchemas[i].institute == 'string') {
            this.allSchemas[i].institute = this.dataService.str2json(this.allSchemas[i].institute);
            if(this.allSchemas[i].institute && this.allSchemas[i].institute.length==1) {
              this.allSchemas[i].institute = this.allSchemas[i].institute[0];
            }
          }
          if(typeof this.allSchemas[i].contacts == 'string') {
            this.allSchemas[i].contacts = this.dataService.str2json(this.allSchemas[i].contacts);
          }
          if(typeof this.allSchemas[i].billing == 'string') {
            this.allSchemas[i].billing = this.dataService.str2json(this.allSchemas[i].billing);
            if(this.allSchemas[i].billing && this.allSchemas[i].billing.length==1) {
              this.allSchemas[i].billing = this.allSchemas[i].billing[0];
            }
          }
          if(typeof this.allSchemas[i].organization == 'string') {
            this.allSchemas[i].organization = this.dataService.str2json(this.allSchemas[i].organization);
            if(this.allSchemas[i].organization && this.allSchemas[i].organization.length==1) {
              this.allSchemas[i].organization = this.allSchemas[i].organization[0];
            }
          }
          if(typeof this.allSchemas[i].pkg_info == 'string') {
            this.allSchemas[i].pkg_info = this.dataService.str2json(this.allSchemas[i].pkg_info);
            if(this.allSchemas[i].pkg_info && this.allSchemas[i].pkg_info.length==1) {
              this.allSchemas[i].pkg_info = this.allSchemas[i].pkg_info[0];
            }
          }
          if(typeof this.allSchemas[i].agreement == 'string') {
            this.allSchemas[i].agreement = this.dataService.str2json(this.allSchemas[i].agreement);
            if(this.allSchemas[i].agreement && this.allSchemas[i].agreement.length==1) {
              this.allSchemas[i].agreement = this.allSchemas[i].agreement[0];
            }
          }

          this.allData.push(this.allSchemas[i]);
        }

        this.loading = false;
      });
    }

	}

  // myKYC(uid: number) {
  //   const retVal = this.allKycs.filter((obj: any)=> {
  //     return obj.user_id==uid;
  //   });

  //   if(retVal && retVal.length > 0) {
  //     return retVal[0];
  //   } else {
  //     return null;
  //   }
  // }

  // isKYC(uid: number) {
  //   const retVal = this.allKycs.filter((obj: any)=> {
  //     return obj.user_id==uid;
  //   });

  //   if(retVal && retVal.length > 0) {
  //     return 'Y';
  //   } else {
  //     return 'N';
  //   }
  // }

  // isTrialUser(user_name: string) {
  //   const userx = this.shCrypt.decrypt(user_name);
  //   if(userx == 'trial' && this.user.is_active) {
  //     return 'Y';
  //   } else {
  //     return 'N';
  //   }
  // }

  orgConnect() {
    this.selOrg = {
      "id": 0,
      "org_code": "DEMO",
      "org_name": "DEMO",
      "org_address": "",
      "org_city": "",
      "org_state": "",
      "org_pincode": "",
      "reg_date": "",
      "is_active": true
    };
  }

	ngOnChanges() {
		if(this.action && this.action=='reload') {
			this.ngOnInit();
		}
	}

  newClick() {
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'user',
      action: 'addnew', data: null
    });
  }

  editClick(myData: any) {
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'user',
      action: 'edit', data: myData
    });
  }

  viewClick(myData: any) {
    if(myData.institute.org_id == 'DEMO') {
      const numbers = '0123456789';
      const customCode1 = this.dataService.getUUID(4, numbers);
      myData.institute.org_id = customCode1;
      myData.organization.org_code = customCode1;
    }

    this.selUser = myData;
    this.selUser["schema"] = myData.source_schema;
    this.selUser["kyc_data"] = {};
    this.selUser.kyc_data["agreement"] = this.selUser.agreement;
    this.selUser.kyc_data["billing"] = this.selUser.billing;
    this.selUser.kyc_data["institute"] = this.selUser.institute;
    this.selUser.kyc_data["contacts"] = this.selUser.contacts;
    this.selUser.kyc_data["organization"] = this.selUser.organization;
    this.selUser.kyc_data["package"] = this.selUser.pkg_info;
    // delete this.selUser.kyc_data["pkg_info"];

    // this.selUser.kyc_data.organization.org_code = '';
    // this.selUser.kyc_data.organization.org_name = '';
    // this.selUser.kyc_data.institute.org_id = '';
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

	async deleteClick(myData: any) {
    const myid: string = myData.id + '@' + myData.source_schema;
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        // console.log('Item deleted successfully');
				this.doDelete(myData.source_schema ? myid : myData.id);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: any) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}
}
